/**
 * Find the nearest snap point from a list of candidates
 * @param {number} position - Current position
 * @param {Array} snapPoints - Array of {position, type, object} objects
 * @param {number} threshold - Snap threshold
 * @returns {Object|null} Nearest snap point or null
 */
export const findNearestSnapPoint = (position, snapPoints, threshold) => {
  let nearestSnap = null;
  let minDistance = threshold;

  snapPoints.forEach((point) => {
    const distance = Math.abs(position - point.position);
    if (distance < minDistance) {
      minDistance = distance;
      nearestSnap = point;
    }
  });

  return nearestSnap;
};
